import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import donto from '../../../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -08.png';

import donto2 from '../../../Images/SUSHENA HOSPITAL & RAJ DIAGNOSTIC CENTRE -14.png';
import dontoAnimated from '../../../Images/cleaner.png';

import './About.css';

const About = () => {

    useEffect(() => {
        AOS.init({
            duration: 2000,
        });
        AOS.refresh();
    }, []);
    return (
        <section className="about-wrapper">
            <Container>
                <Row>
                    <Col md={12} lg={6}>
                        <div className="about-left">
                            <img src={donto} alt="donto" className="img-fluid donto" />

                        </div>
<br/>
                        <div className="about-left">
                            <img src={donto2} alt="donto" className="img-fluid donto" />

                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className="about-right mt-5 mt-lg-0">
                            <div className="about-content text-start" data-aos="zoom-in">
                                <h1>Welcome to Sushena Hospital</h1>
                                <p><b style={{fontSize: '22px'}}>Sushena Hospital and <b style={{fontSize: '22px'}}>Raj Diagnostics</b></b>" was founded by <b><u>Dr, Divya Verma</u></b> in the year 2015, This is among the few hospitals opened in Lucknow which openly take care of every individual patient trauma with the help of 24/7 staff members availability. They have been helping people with discounts and less fee structure.
                                    They are registered with the" Red Cross" and well equipped with all medical care facilities which enable us to become a destination of choice for healthcare seekers in India and abroad.</p>


                                <h1>About Doctor</h1>
                                <p> <b> DR Divya Verma</b> as ownership running hospital since 2014. with cooperation of look oriented and & patient Caring team nursing and paramedical staff" devoted Dr. Divya Verma having lifetime membership in the Red cross Society</p>
                            </div>


                            
                            <div className="fun-fact-sec" data-aos="fade-right">
                                <div className="single-fun">
                                    <span>500</span>
                                    <span>+</span>
                                    <p>Happy Patients</p>
                                </div>
                                <div className="single-fun sp-fun" data-aos="fade-right">
                                    <span>88</span>
                                    <span>+</span>
                                    <p>Qualified Doctors</p>
                                </div>
                                <div className="single-fun" data-aos="fade-left">
                                    <span>08</span>
                                    <span>+</span>
                                    <p>Years Experience</p>
                                </div>
                                <div className="single-fun sp-fun" data-aos="fade-left">
                                    <span>50</span>
                                    <span>+</span>
                                    <p>Dental Awards</p>
                                </div>
                                <span className="line"></span>
                            </div>
                        </div>

                        
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default About;